import React from 'react';
import { Typography } from '@mui/material';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import DescriptionIcon from '@mui/icons-material/Description';
import SchoolIcon from '@mui/icons-material/School';
import LocalCafeIcon from '@mui/icons-material/LocalCafe';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import BedtimeIcon from '@mui/icons-material/Bedtime';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ACTIVITY_TYPE_COLORS } from '../plannerMockData';
import { minutesToTimeLabel, PIXELS_PER_MINUTE } from '../plannerUtils';

export const ACTIVITY_TYPE_ICONS = {
  Project: WorkOutlineIcon,
  Task: TaskAltIcon,
  Meeting: GroupsIcon,
  Administration: DescriptionIcon,
  Training: SchoolIcon,
  Break: LocalCafeIcon,
  Lunch: RestaurantIcon,
  Sleep: BedtimeIcon,
  Travel: DirectionsCarFilledIcon,
  Other: MoreHorizIcon,
};

const ActivityBlock = ({
  activity,
  gridStartMinutes,
  label,
  readOnly,
  isDragging,
  onSelect,
  onMoveStart,
  onResizeStart,
  onClone,
}) => {
  const color = ACTIVITY_TYPE_COLORS[activity.type] || '#546e7a';
  const top = (activity.startMinutes - gridStartMinutes) * PIXELS_PER_MINUTE;
  const height = Math.max((activity.endMinutes - activity.startMinutes) * PIXELS_PER_MINUTE, 18);
  const isCompact = height < 40;
  const isTiny = height < 26;
  const TypeIcon = ACTIVITY_TYPE_ICONS[activity.type] || MoreHorizIcon;

  return (
    <div
      className={`planner-activity-block${readOnly ? ' readonly' : ''}${isDragging ? ' dragging' : ''}`}
      style={{
        top,
        height,
        backgroundColor: `${color}1c`,
        borderLeftColor: color,
      }}
      onMouseDown={(e) => {
        if (readOnly) return;
        e.stopPropagation();
        onMoveStart(e, activity);
      }}
      onClick={(e) => {
        e.stopPropagation();
        onSelect(activity);
      }}
      title={`${label}\n${minutesToTimeLabel(activity.startMinutes)} – ${minutesToTimeLabel(activity.endMinutes)}`}
    >
      <div className="planner-activity-block-body">
        <div className="planner-activity-title-row">
          {!isTiny && <TypeIcon className="planner-activity-icon" style={{ color }} />}
          <Typography variant="caption" className="planner-activity-title" sx={{ color }}>
            {label}
          </Typography>
        </div>
        {!isCompact && (
          <Typography variant="caption" className="planner-activity-time">
            {minutesToTimeLabel(activity.startMinutes)} – {minutesToTimeLabel(activity.endMinutes)}
          </Typography>
        )}
      </div>
      {!readOnly && !isTiny && (
        <button
          type="button"
          className="planner-activity-clone-btn"
          aria-label="Duplicate activity"
          title="Duplicate"
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            onClone(activity);
          }}
        >
          <ContentCopyIcon fontSize="inherit" />
        </button>
      )}
      {!readOnly && (
        <>
          <div
            className="planner-activity-resize-handle top"
            onMouseDown={(e) => {
              e.stopPropagation();
              onResizeStart(e, activity, 'top');
            }}
          />
          <div
            className="planner-activity-resize-handle bottom"
            onMouseDown={(e) => {
              e.stopPropagation();
              onResizeStart(e, activity, 'bottom');
            }}
          />
        </>
      )}
    </div>
  );
};

export default ActivityBlock;
